import Vue from 'vue'
import Router from 'vue-router'
import Index from "./components/Index.vue";

Vue.use(Router);

const getBasePath = () => {
	if (window.events_data.locale === 'en') {
		return '/events'
	}
	// see if url path begins with jp-refresh or jp...
	const path = window.location.pathname
	if (path.startsWith('/jp-refresh')) {
		
		return '/jp-refresh/events'
	}

	return '/jp/events'
}

export default new Router({
	mode: 'history',
	//base: '/events', //un-comment this line for local environment
	base: getBasePath(),
	routes: [
		{
			path: '/',
			name: 'index',
			component: Index,
			// Automatic region selection for non-en locales
			beforeEnter: (to, from, next) => {
				if (to.fullPath === '/' && from.fullPath === '/' && Object.keys(from.query).length === 0) {
					if (window.events_data.locale === 'ja'){
						next({ name: 'index', query: {regions: "APAC" }})
					}
				}

				next()
			}
		}
	],
})
